{
  "es": {
    "phase": {
      "attributes": {
        "end_date": "Fecha de fin",
        "internal_note": "Nota interna de la fase",
        "name": "Nombre",
        "start_date": "Fecha de inicio"
      },
      "labels": {
        "phase": "Ninguna fase | Una fase | {count} fases"
      },
      "toasts": {
        "create": "Fase creada",
        "delete": "Fase eliminada",
        "update": "Fase actualizada"
      },
      "validation": {
        "needName": "Se requiere un título",
        "needNumber": "Debe ser un número (p. ej. 85)"
      }
    }
  }
}
